import React from 'react';
import { useQuery } from '@apollo/client';
import { GetSemesterPaymentPlansDocument } from '@sandtech-hub-monorepo/ehub-client';
import { ActivePaymentsTab } from './ActivePaymentsTab';
import { CancelledPaymentsTab } from './CancelledPaymentsTab';
import { Loading } from '@sandtech-hub-monorepo/ui-kit-site';
import { Info } from 'lucide-react';

export const PaymentsTab = () => {
  const { data, loading } = useQuery(GetSemesterPaymentPlansDocument);

  const paymentPlan = data?.viewer.paymentPlans?.[0];

  if (loading) {
    return (
      <div className="flex items-center justify-center">
        <Loading />
      </div>
    );
  }

  if (!paymentPlan) {
    return (
      <div className="flex justify-center items-center min-h-[400px]">
        <div className="p-8 max-w-md text-center">
          <div className="flex flex-col gap-4 items-center">
            <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center">
              <Info className="w-8 h-8 text-muted-foreground" />
            </div>
            <div className="flex flex-col gap-2">
              <p className="font-semibold text-lg">No Payment Plan</p>
              <p className="text-sm text-muted-foreground">
                You don't have a payment plan yet. A payment plan will be
                created once you enroll in a program.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return paymentPlan.status === 'CANCELLED' ? (
    <CancelledPaymentsTab paymentPlan={paymentPlan} />
  ) : (
    <ActivePaymentsTab paymentPlan={paymentPlan} />
  );
};
